<template>
  <div class="requestshipment">
    <div
      class="requestshipment__container"
      v-if="$route.params.step !== stepName"
    >
      <FreightMode />
    </div>

    <div v-else>
      <div class="position-relative" style="height: 300px; margin-top: -1px;">
        <div
          class="w-100 position-fixed"
          style="background-color: #fff;z-index: 100;"
        >
          <div class="d-flex justify-content-between mr-4 ml-4 mb-2 mt-2">
            <div>
              <router-link
                to="/request-shipment"
                class="button__bluecorporite d-flex justify-content-center align-items-center"
                style="text-decoration: none;"
              >
                <img
                  class="mr-2"
                  src="@/assets/image/icon/icon-rectangle.svg"
                />
                Back
              </router-link>
            </div>
            <div>
              <button class="button__bluecorporite" @click="checkSubmit">
                <div
                  v-if="spinnerShow"
                  class="spinner-border"
                  role="status"
                  style="width: 1rem !important;height: 1rem !important;"
                >
                  <span class="sr-only">Loading...</span>
                </div>
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <p v-if="messageError" class="fontstyle__errormsg text-left ml-2">
              {{ messageError }}
            </p>
          </div>
          <HeaderShipmentType :dataHeader="dataShipment" />
        </div>
      </div>
      <FormShipmentLand
        v-if="$route.query.mode === 'LAND'"
        @inputData="currentDataHeader"
        :submitCheck="submitCheck"
        @callBackSubmit="submitCreateShipmet"
      />
      <FormShipmentAir
        v-if="$route.query.mode === 'AIR'"
        @inputData="currentDataHeader"
        :submitCheck="submitCheck"
        @callBackSubmit="submitCreateShipmet"
      />
      <FormShipmentOcean
        v-if="$route.query.mode === 'OCEAN'"
        @inputData="currentDataHeader"
        :submitCheck="submitCheck"
        @callBackSubmit="submitCreateShipmet"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import HeaderShipmentType from '@/components/requestShipment/newRequestShipment/HeaderShipmentRfq'
import FreightMode from '@/components/requestShipment/newRequestShipment/FreightMode'
import FormShipmentLand from '@/components/requestShipment/newRequestShipment/FormShipmentLand'
import FormShipmentAir from '@/components/requestShipment/newRequestShipment/FormShipmentAir'
import FormShipmentOcean from '@/components/requestShipment/newRequestShipment/FormShipmentOcean'
import mixin from '@/mixin'

export default {
  name: 'requestshipment',
  components: {
    HeaderShipmentType,
    FreightMode,
    FormShipmentLand,
    FormShipmentAir,
    FormShipmentOcean
  },
  mixins: [mixin],
  data() {
    return {
      stepName: 'type-shipment',
      data: {},
      submitCheck: false,
      spinnerShow: false,
      maximalTotalNumber: 9999999,
      messageError: '',
      dataShipment: {}
    }
  },
  computed: {
    ...mapGetters({
      createdRfq: 'rfq/created',
      createdRfqError: 'rfq/error',
      createdRfqIsLoading: 'rfq/isLoading',
      // auth
      auth: 'auth/profile',
      authError: 'auth/error',
      authIsLoading: 'auth/isLoading'
    })
  },
  methods: {
    submitCreateShipmet(data) {
      if (data === false) {
        this.messageError = 'Check your data'
        setTimeout(() => {
          this.messageError = ''
        }, 3000)
      } else {
        this.spinnerShow = true
        this.messageError = ''
        this.data = data
        if (
          this.data.totalUnit > this.maximalTotalNumber ||
          this.data.totalVolumetric > this.maximalTotalNumber ||
          this.data.totalWeight > this.maximalTotalNumber ||
          this.data.totalCBM > this.maximalTotalNumber
        ) {
          this.messageError = `Total Quantity, Total Weight or Total Volume is out of range. Maximal is ${this.maximalTotalNumber}, please check data`
          setTimeout(() => {
            this.messageError = ''
          }, 3000)
          this.spinnerShow = false
        } else {
          const formData = new FormData()
          // // mandatory ke BE tapi sebenarnya uda gak di pake
          if (this.data.selectedFilter === 'AIRCARGO') {
            this.dimension = {
              length: this.data.loadsAIRCargo[0].length,
              width: this.data.loadsAIRCargo[0].width,
              height: this.data.loadsAIRCargo[0].height
            }
            this.packingList = this.data.loadsAIRCargo
          } else if (this.data.selectedFilter === 'AIRCOURIER') {
            this.dimension = {
              length: this.data.loadsAIRCourier[0].length,
              width: this.data.loadsAIRCourier[0].width,
              height: this.data.loadsAIRCourier[0].height
            }
            this.packingList = this.data.loadsAIRCourier
          } else if (this.data.selectedFilter === 'AIRBREAKBULK') {
            this.dimension = {
              length: this.data.loadsAIRBreakbulk[0].length,
              width: this.data.loadsAIRBreakbulk[0].width,
              height: this.data.loadsAIRBreakbulk[0].height
            }
            this.packingList = this.data.loadsAIRBreakbulk
          } else if (this.data.selectedFilter === 'SEALCL') {
            this.dimension = {
              length: this.data.loadsLCL[0].length,
              width: this.data.loadsLCL[0].width,
              height: this.data.loadsLCL[0].height
            }
            this.packingList = this.data.loadsLCL
          } else if (this.data.selectedFilter === 'SEABREAKBULK') {
            this.dimension = {
              length: this.data.loadsSEABreakbulk[0].length,
              width: this.data.loadsSEABreakbulk[0].width,
              height: this.data.loadsSEABreakbulk[0].height,
              uom: this.data.loadsSEABreakbulk[0].uom.value
            }
            this.packingList = this.data.loadsSEABreakbulk
            this.packingList.filter((el, i) => {
              this.packingList[i].uom = el.uom.value
            })
          } else if (this.data.selectedFilter === 'SEAFCL') {
            this.dimension = {
              length: this.data.loadsSEAFCL[0].length,
              width: this.data.loadsSEAFCL[0].width,
              height: this.data.loadsSEAFCL[0].height
            }
            this.packingList = this.data.loadsSEAFCL
            this.packingList.filter((el, i) => {
              this.packingList[i].shipmentType = el.shipmentType.value
              this.packingList[i].containerType = el.containerType.value
              this.packingList[i].containerOption = el.containerOption.value
              if (i === this.packingList.length - 1) {
                this.lastArray = {
                  containerType: el.containerType,
                  containerOption: el.containerOption,
                  temperature: el.temperature
                }
              }
            })
          } else if (this.data.selectedFilter === 'BARGE') {
            this.packingList = this.data.loadsSEABarge
            this.dimension = {
              length: this.data.loadsSEABarge[0].length,
              width: this.data.loadsSEABarge[0].width,
              height: this.data.loadsSEABarge[0].height
            }
          } else if (this.data.selectedFilter === 'LCT') {
            this.packingList = this.data.loadsSEALCT
            this.dimension = {
              length: this.data.loadsSEALCT[0].length,
              width: this.data.loadsSEALCT[0].width,
              height: this.data.loadsSEALCT[0].height
            }
          }

          if (this.$route.query.mode === 'LAND') {
            formData.append('serviceHead', this.data.serviceHead)
            formData.append('tmsDepartureTime', this.data.tmsDepartureTime)
            formData.append('tmsCodAmount', this.data.tmsCodAmount)
            formData.append('tmsFleetCategory', this.data.tmsFleetCategory)
            formData.append('tmsFleetType', this.data.tmsFleetType)
            formData.append('tmsOrigin', this.data.tmsOrigin)
            formData.append('tmsDestination', this.data.tmsDestination)
            formData.append('tmsOriginCity', this.data.tmsOriginCity)
            formData.append('tmsDestinationCity', this.data.tmsDestinationCity)
            formData.append('tmsOriginAddress', this.data.tmsOriginAddress)
            formData.append(
              'tmsDestinationAddress',
              this.data.tmsDestinationAddress
            )
          } else {
            this.packingList.filter((el, i) => {
              this.packingList[i].qty = parseFloat(el.qty)
              this.packingList[i].weight = parseFloat(el.weight)
              this.packingList[i].width = parseFloat(el.width)
              this.packingList[i].length = parseFloat(el.length)
              this.packingList[i].height = parseFloat(el.height)
              if (
                this.data.selectedFilter === 'BARGE' ||
                this.data.selectedFilter === 'LCT'
              ) {
                this.packingList[i].note = el.note
                this.packingList[i].satuan = el.satuan
              } else {
                this.packingList[i].satuan = el.satuan.value
              }
            })
            // shipment type
            if (
              this.data.selectedFilter === 'BARGE' ||
              this.data.selectedFilter === 'LCT'
            ) {
              formData.append('optiontp', 'ptp')
            } else {
              formData.append('optiontp', this.data.selectedServiceType)
            }
            formData.append('serviceHead', this.$route.query.mode)
            formData.append('shipmentType', this.data.selectedFilter)
            formData.append('packingList', JSON.stringify(this.packingList))
            formData.append('dimension', JSON.stringify(this.dimension))
            // shipment type - Ocean
            if (this.lastArray) {
              formData.append(
                'containerType',
                this.lastArray.containerType || ''
              )
              formData.append(
                'containerOption',
                this.lastArray.containerOption || ''
              )
              formData.append('temperature', this.lastArray.temperature || '')
            }

            // // product type
            formData.append('productClass', this.data.selectedProduct)
            formData.append('productDescription', this.data.commodities)
            formData.append('unNumber', this.data.unNumber)
            formData.append('poNumber', this.data.poNumber)

            // // route
            formData.append(
              'customerPosition',
              this.data.customerPosition.value
            )
            formData.append('routeType', this.data.routeType.value)
            formData.append('datePickup', this.data.datePickup)
            formData.append(
              'originCountryCode',
              this.data.originCountryCode.code
            )
            formData.append('originCityCode', this.data.originCityCode.code)
            formData.append(
              'destinationCountryCode',
              this.data.destinationCountryCode.code
            )
            formData.append(
              'destinationCityCode',
              this.data.destinationCityCode.code
            )
            formData.append('pickupAddress', this.data.pickupAddress)
            formData.append('deliveryAddress', this.data.deliveryAddress)

            // // Additional
            formData.append('insuranceId', this.data.selectedInsurance.id)
            formData.append('remark', this.data.remarks)
            formData.append('insurance', true)
            formData.append('warehouse', this.data.warehouse)
            formData.append('consigneeUndername', this.data.consigneeUndername)
            formData.append('shipperUndername', this.data.shipperUndername)
            formData.append('satuan', data.satuan ? data.satuan : '')
            formData.append(
              'qtyperPackage',
              this.data.qtyperPackage ? this.data.qtyperPackage : null
            )
            // //
            formData.append('fileDocument', this.data.fileDocument)

            // vessel
            formData.append('hsCode', this.data.hsCode ? this.data.hsCode : '')
            if (
              this.data.selectedFilter === 'BARGE' ||
              this.data.selectedFilter === 'LCT'
            ) {
              formData.append('loadDate', this.data.loadDate)
              formData.append(
                'productType',
                this.data.productType ? this.data.productType.name : ''
              )
              formData.append('filePackingList', this.data.filePackingList)
              formData.append(
                'containerType',
                this.data.containerType ? this.data.containerType : ''
              )
            }
          }
          this.$store.dispatch('rfq/CREATE_RFQ', formData).then(res => {
            this.spinnerShow = false
            if (res.status <= 201) {
              this.$eventHub.$emit('dialog-rfq-tolist')
            } else {
              const errorMessage =
                res.data.message || 'Failed to create quotation'
              if (
                this.$route.query.mode === 'LAND' &&
                errorMessage.includes('errorMcEasy')
              ) {
                this.$eventHub.$emit('dialog-error-mceasy-rfq-land')
              } else {
                this.$eventHub.$emit(
                  'dialog-error-create-quotation',
                  errorMessage
                )
              }
            }
          })
        }
      }
    },
    currentDataHeader(data) {
      const type = data.selectedFilter ? data.selectedFilter : data
      console.log(type)
      if (type === 'AIRCARGO') {
        this.dataShipment = {
          shipmenttype: 'AIR CARGO',
          origin: data.originCityCode,
          destination: data.destinationCityCode,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-air-cargo.svg'),
          text:
            'End to end service for your medium to large quantities shipment',
          InfoShipment: [
            { title: 'Total Quantity', value: `${data.totalUnit || 0}` },
            { title: 'Total Weight', value: `${data.totalWeight || 0}` },
            { title: 'Volumetric', value: `${data.totalVolumetric || 0}` }
          ]
        }
      } else if (type === 'AIRCOURIER') {
        this.dataShipment = {
          shipmenttype: 'AIR COURIER',
          origin: data.originCityCode,
          destination: data.destinationCityCode,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-air-courier.svg'),
          text: 'End to end service for your small quantities shipment',
          InfoShipment: [
            { title: 'Total Quantity', value: `${data.totalUnit || 0}` },
            { title: 'Total Weight', value: `${data.totalWeight || 0} ` },
            { title: 'Volumetric', value: `${data.totalVolumetric || 0}` }
          ]
        }
      } else if (type === 'AIRBREAKBULK') {
        this.dataShipment = {
          shipmenttype: 'AIR BREAKBULK',
          origin: data.originCityCode,
          destination: data.destinationCityCode,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-shipment-breakbulk.svg'),
          text:
            'Ship your medium-large quantity goods faster with Air Breakbulk.',
          InfoShipment: [
            { title: 'Total Quantity', value: `${data.totalUnit || 0}` },
            { title: 'Total Weight', value: `${data.totalWeight || 0}` },
            { title: 'Volumetric', value: `${data.totalVolumetric || 0}` }
          ]
        }
      } else if (type === 'SEAFCL') {
        this.dataShipment = {
          shipmenttype: 'Full Container Load (FCL)',
          origin: data.originCityCode,
          destination: data.destinationCityCode,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-ocean-fcl.svg'),
          text:
            'Get the best rates for your shipment to all around the world with FCL services.'
        }
      } else if (type === 'SEALCL') {
        this.dataShipment = {
          shipmenttype: 'Less Container Load (LCL)',
          origin: data.originCityCode,
          destination: data.destinationCityCode,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-ocean-lcl.svg'),
          text:
            'Get the best rates for your shipment to all around the world with LCL services.',
          InfoShipment: [
            { title: 'Total Quantity', value: `${data.totalUnit || 0}` },
            { title: 'Total Weight', value: `${data.totalWeight || 0}` },
            { title: 'Volumetric', value: `${data.totalCBM || 0}` }
          ]
        }
      } else if (type === 'SEABREAKBULK') {
        this.dataShipment = {
          shipmenttype: 'Ocean Breakbulk',
          origin: data.originCityCode,
          destination: data.destinationCityCode,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-shipment-breakbulk.svg'),
          text:
            'Get the best rates for your shipment to all around the world with Breakbulk services.',
          InfoShipment: [
            { title: 'Total Quantity', value: `${data.totalUnit || 0}` },
            { title: 'Total Weight', value: `${data.totalWeight || 0}` },
            {
              title: 'Total Volume',
              value: `${this.getCurrency(data.totalVolumetric) || 0}`
            }
          ]
        }
      } else if (type === 'BARGE') {
        this.dataShipment = {
          shipmenttype: 'Barge',
          containerType: data.containerType,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-vessel.svg'),
          text: 'Input your shipment, product and your vessel specification'
        }
      } else if (type === 'LCT') {
        this.dataShipment = {
          shipmenttype: 'LCT',
          containerType: data.containerType,
          routeType: data.routeType,
          img: require('@/assets/image/icon/icon-vessel.svg'),
          text: 'Input your shipment, product and your vessel specification'
        }
      } else {
        this.dataShipment = {
          shipmenttype: 'LAND',
          img: require('@/assets/image/icon/truck-fast.svg'),
          text: 'Fill your land shipping order details below.'
        }
      }
      return this.dataShipment
    },
    getCurrency(value) {
      let newValue = ''
      if (value) {
        newValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return newValue
    },
    checkSubmit() {
      this.submitCheck = true
      setTimeout(() => {
        this.submitCheck = false
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/requestShipment/index.vue